// Helpers.
import i18n from './reacti18n';
import Page from './page';

// BNA title short version threshold
const bnaSectionTitleLimits = {
  desktop: 36,
  tablet: 36,
  mobile: 21,
};

const callusMessage = (loggedOutMessage, loggedInMessage) => (document.body.getAttribute('isloggedin') ? loggedInMessage : loggedOutMessage);

/**
 *  Get BNA title as part of experiment
 *  If 'For {firstName}' length is less than the BNA title threshold then display 'For FirstName' if not just display 'For you'
 */
const getBNATitle = () => {
  const firstName = Page.getUserFirstName();
  if (firstName && typeof firstName === 'string') {
    const bnaUserTitle = i18n.message('smarthelp/home.home.forUser', { firstName });
    if (bnaUserTitle.length <= bnaSectionTitleLimits[Page.getDeviceType()]) {
      return bnaUserTitle;
    }
  }
  return i18n.message('smarthelp/home.home.forYou');
};

// export default callusMessage;
module.exports = {
  getBNATitle,
  callusMessage,
};
